import React from 'react';

import Spinner from 'brandComponents/Spinner';

const FiltersRefinementLoading = () => {
	return <div><Spinner fullScreen type="rounded"/></div>;
};

export default FiltersRefinementLoading;